$( document ).on("turbo:load", initSortableTables);

// to use sortable table
// - add the sortable-table class to the tbody you want to make sortable
// - add a data-order-url to the tbody which has the url you want to handle the update
// - ensure that each tr in the tbody has a data-object-id of the object id in the DB

function initSortableTables() {
  $('tbody.sortable-table').not('.sortable-initialized').each(function(){
    // add a empty column to each row in the thead
    tbody = $(this);
    tbody.siblings('thead').children('tr').prepend('<th></th>');
    handle_td = "<td class='handle'><i class='glyphicon glyphicon-sort' /></td>";
    tbody.children('tr').prepend(handle_td);
    // add a form to submit new order
    form_id = 'sortable_table_form_' + Math.floor(Math.random() * 100000000);
    loading_image = tbody.data('loading-image') || '/assets/loading.gif';
    form_content = "<form class='form sortable-order-form' id='" + form_id + "' action='#'><input class='btn btn-primary' type='submit' value='Save current order' /><img style='display:none;' src='" + loading_image + "' /></form>";
    tbody.parents('table').after(form_content);
    // set form to update order with ajax 
    form = $('#' + form_id);
    form.submit(function(e) {
      e.preventDefault();
      data = []
      tbody.children('tr').each(function(){
        data.push($(this).data('object-id'));
      });
      order_url = tbody.data('order-url');
      $.post(order_url, {order: data}, function(){
        form.children('img').hide();         
        form.children('input').show();         
      });
      form.children('input').hide();         
      form.children('img').show();         
    });
    // make sortable
    $(this).sortable({axis: 'y', handle: '.handle'});
    // mark as initialized
    tbody.addClass('sortable-initialized');
  });
}
